// extracted by mini-css-extract-plugin
export default {"wrapper":"ProductView_wrapper__GKMj9"};